/** Largeur max du contenu principal sur grand écran (px). */
export const PAGE_CONTENT_MAX_WIDTH_PX = 1200;

/** Gouttière horizontale à l’intérieur du conteneur (px). */
export const PAGE_CONTENT_GUTTER_PX = 16;
